import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import CryptoJS from "crypto-js";
import DatePicker from "react-datepicker";
import br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

export default function Edit_Usuario({ history }) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [telefone, setTelefone] = useState("1");
  const [loading, setLoading] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCliente, setIsCliente] = useState(false);
  const [isConsultor, setIsConsultor] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [idempresa, setIdempresa] = useState("");
  const [treinamentos, setTreinamentos] = useState([]);
  const [idproduto, setIdproduto] = useState("");
  const [idprodutoCliente, setIdprodutoCliente] = useState("");
  const [produtos, setProdutos] = useState([]);
  const [produtosInt, setProdutosInt] = useState([]);
  const [datatreinamento, setDataTreinamento] = useState(new Date());
  /** Catálogo do modal “Adicionar Treinamento”: só treinos em treinamentosPermitidos da empresa */
  const [produtosModalTreinamentos, setProdutosModalTreinamentos] = useState(
    []
  );

  const url_string = window.location.href;
  const param = url_string.split("/");
  const isMaster = localStorage.getItem("sgimaster")

  const checkadmin = () => {
    const b_admin = localStorage.getItem("sgiadmin");
    if (b_admin != "true") history.push("/painel");
  };

  async function loadEmpresas() {
    const query = "/treinamentos/empresa";
    const response = await api.get(query);
    const data = await response.data;
    setEmpresas(data);
  }

  async function loadTreinamentos() {
    //metodo para carrgar treinamentoclientes por usuario    
    const query = "/treinamentos/produtocliente/usuario/" + param[4];
    const response = await api.get(query);
    const data = await response.data;
  
    setTreinamentos(data);
    setLoading(false);
  }

  async function loadCatalogosPorTenant(tenantId) {
    if (!tenantId) {
      setProdutos([]);
      setProdutosInt([]);
      return;
    }
    const hdr = {
      "x-tenantid": tenantId,
      isMaster: localStorage.getItem("sgimaster"),
    };
    const response1 = await api.get("/treinamentos/produto", {
      headers: hdr,
    });
    setProdutos(response1.data || []);
    const response2 = await api.get("/treinamentos/produto/integracao", {
      headers: hdr,
    });
    setProdutosInt(response2.data || []);
  }

  async function loadEmpresaPermitidos(empresaId) {
    if (!empresaId) {
      setProdutosModalTreinamentos([]);
      return;
    }
    try {
      const r = await api.get("/treinamentos/empresa/" + empresaId);
      const d = r.data;
      const permitidos = (d[0] && d[0].treinamentosPermitidos) || [];
      const ids = permitidos.map((x) => String(x));

      if (ids.length === 0) {
        setProdutosModalTreinamentos([]);
        return;
      }

      const empresaid = localStorage.getItem("sgiempresaid");
      const isMaster = localStorage.getItem("sgimaster");
      const body = ids.map((id) => ({ id }));
      const resp = await api.post("/treinamentos/produto/idlist", body, {
        headers: { "x-tenantid": empresaid || empresaId, isMaster },
      });
      const lista = (resp.data || []).filter((p) => !p.isIntegracao);
      setProdutosModalTreinamentos(lista);
    } catch (e) {
      setProdutosModalTreinamentos([]);
    }
  }

  async function loadProd() {
    const response = await api.get("/treinamentos/usuarios/" + param[4]);
    const data = await response.data;

    setNome(data[0].nome);
    setEmail(data[0].email);
    setTelefone(data[0].telefone);
    setIsAdmin(data[0].isAdmin);
    setIsCliente(data[0].isCliente);
    setIsConsultor(data[0].isConsultor);
    const tenantId = data[0].idempresa;
    setIdempresa(tenantId);
    await loadCatalogosPorTenant(tenantId);
    await loadEmpresaPermitidos(tenantId);

    const dateToday = new Date();
    dateToday.setDate(dateToday.getDate() + 30);
    setDataTreinamento(dateToday);

    setLoading(false);
  }

  async function addNewItem() {
    setLoading(true);

    const dataobj = {
      idtreinamento: idproduto,
      prazo: datatreinamento
    };

    await api.put("/treinamentos/usuarios/addTreinamento/" + param[4], dataobj)
    .catch(async (res) => {
      alert("Treinamento já está associado ao usuário");
      setIdproduto("");
      setLoading(false);
    });
    
    setTimeout(() => {
      setIdproduto("");
      loadTreinamentos();
      setLoading(false);
    }, 1500);
  }

  async function removeItem(id) {
    setLoading(true);

    const dataobj = {
      idtreinamento: id,
    };
    
    await api.put("/treinamentos/usuarios/removeTreinamento/delete/" + param[4], dataobj);
    setLoading(false);
    loadTreinamentos();
  }

  async function editItem(id) {
    setLoading(true);

    //put no produtoclienteid
    //atualizando a dataDueDate

    const dataobj = {
      dataDueDate: datatreinamento,
    };
    
    await api.put("/treinamentos/produtocliente/" + id, dataobj);
    setLoading(false);
    loadTreinamentos();
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();
    let dataobj;
    if (pwd === "") {
      dataobj = {
        nome: nome,
        email: email,
        telefone: telefone,
        isAdmin,
        isConsultor,
        isCliente,
        idempresa,
      };
    } else {
      const hashPwd = CryptoJS.SHA3(pwd).toString();
      dataobj = {
        nome: nome,
        email: email,
        pwd: hashPwd,
        telefone: telefone,
        isAdmin,
        isConsultor,
        isCliente,
        idempresa,
      };
    }

    await api.put("/treinamentos/usuarios/" + param[4], dataobj);
    history.push("/usuarios");
  }

  useEffect(() => {
    setLoading(true);
    checkadmin();
    loadEmpresas();
    loadProd();
    loadTreinamentos();
    setTimeout(() => {
      if (document.getElementById("menu_usuario")) {
        document.getElementById("menu_usuario").className = "active";
      }
    }, 50);
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            Edição Usuário: {nome}
            {email ? <small>&nbsp;( {email} )</small> : null}
          </h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-primary">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80"></img>
                  </div>
                )}
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="nome">
                        Nome*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="nome"
                          placeholder="Nome Completo do Usuário"
                          className="form-control"
                          required
                          maxLength={160}
                          value={nome}
                          onChange={(event) => setNome(event.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="preco">
                        E-mail*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="email"
                          placeholder="E-mail do Usuário"
                          className="form-control"
                          required
                          maxLength={100}
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="nome">
                        Senha*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="nome"
                          type="password"
                          placeholder="Senha do Usuário"
                          className="form-control"
                          maxLength={50}
                          value={pwd}
                          onChange={(event) => setPwd(event.target.value)}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group">
                      <label
                        className="col-sm-2"
                        htmlFor="preco"
                      >
                        Telefone
                      </label>
                      <div className="col-sm-4">
                      <input
                        id="email"
                        placeholder="Telefone do Usuário"
                        className="form-control"
                        required
                        maxLength={14}
                        value={telefone}
                        onChange={event => setTelefone(event.target.value)}
                        />
                        </div>
                    </div> */}

                    {/*
                        
                          if access_web === true 
                          show dropbox to inform if it is a Checklist creator or Checklist Approver
                          create property to usuario model and include new field named web_resp
                          0 = Creator
                          1 = Approver

                        */}

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="idcompressor">
                        Empresa*
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="idcompressor"
                          value={idempresa}
                          placeholder="Empresa do usuário"
                          className="form-control select2"
                          required
                          disabled={isMaster == "false"}
                          onChange={async (event) => {
                            const v = event.target.value;
                            setIdempresa(v);
                            setIdproduto("");
                            await loadCatalogosPorTenant(v);
                            await loadEmpresaPermitidos(v);
                          }}
                        >
                          <option key="" value="" disabled>
                            -- Selecione --
                          </option>
                          {empresas.map((empresa) => (
                            <option key={empresa._id} value={empresa._id}>
                              {empresa.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="preco">
                        Área de Acesso*
                      </label>
                      <div className="checkbox">
                        <label style={{ paddingLeft: 35 }}>
                          <input
                            id="isAdmin"
                            type="checkbox"
                            checked={isAdmin === true ? "checked" : ""}
                            onChange={(event) => {
                              setIsAdmin(!isAdmin);
                            }}
                          />
                          Administrador
                        </label>
                      </div>
                    </div>

                    <div className="nav-tabs-custom">
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a
                            href="#tab_1"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Treinamentos
                          </a>
                        </li>
                        <li>
                          <a
                            href="#tab_2"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Integração
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div className="tab-pane active" id="tab_1">
                          <div className="row">
                            <div className="col-xs-12">
                              <div className="box">
                                {/* /.box-header */}
                                <div className="box-body table-responsive no-padding">
                                  <table className="table table-hover">
                                    <tbody>
                                      <tr>
                                        <th>#</th>
                                        <th>Treinamento</th>
                                        <th>Prazo</th>
                                        <th>Ação</th>
                                      </tr>

                                      {treinamentos &&
                                        treinamentos.filter(treinamento => (treinamento.isIntegracao == false)).map((item, index) => (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>{item.titulo}</td>
                                            <td>{new Date(item.dataDueDate).toLocaleDateString('pt-BR')}</td>
                                            <td>
                                              <a 
                                              onClick={() => {
                                                setIdproduto(item.idtreinamentoOriginal);
                                                setIdprodutoCliente(item._id);
                                                setDataTreinamento(new Date(item.dataDueDate));
                                                }
                                              }
                                              data-toggle="modal"
                                              data-target="#modal-edititem"
                                              type="button"
                                              style={{ cursor: "pointer" }}>
                                                  <i
                                                  class="fa fa-edit"
                                                  style={{ color: "blue" }}
                                                ></i>
                                              </a>&nbsp;&nbsp;
                                              <a 
                                               onClick={() =>
                                                removeItem(item._id)
                                              }
                                              style={{ cursor: "pointer" }}>
                                                  <i
                                                  class="fa fa-remove"
                                                  style={{ color: "red" }}
                                                ></i>
                                              </a>
                                            </td>
                                            
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                  <br></br>
                                </div>

                                <button
                                  className="btn btn-success"
                                  data-toggle="modal"
                                  data-target="#modal-newitem"
                                  type="button"
                                  style={{ marginRight: 8 }}
                                >
                                  + Adicionar Novo Treinamento
                                </button>

                                <p>&nbsp;</p>
                                {/* /.box-body */}
                              </div>
                              {/* /.box */}
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tab_2">
                        <div className="row">
                            <div className="col-xs-12">
                              <div className="box">
                                {/* /.box-header */}
                                <div className="box-body table-responsive no-padding">
                                  <table className="table table-hover">
                                    <tbody>
                                      <tr>
                                        <th>#</th>
                                        <th>Integração</th>
                                        <th>Prazo</th>
                                        <th>Ação</th>
                                      </tr>

                                      {treinamentos &&
                                        treinamentos.filter(treinamento => (treinamento.isIntegracao == true)).map((item, index) => (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>{item.titulo}</td>
                                            <td>{new Date(item.prazo).toLocaleDateString('pt-BR')}</td>
                                            <td>
                                              <a 
                                               onClick={() =>
                                                removeItem(item._id)
                                              }
                                              style={{ cursor: "pointer" }}>
                                                  Remover <i
                                                  class="fa fa-remove"
                                                  style={{ color: "red" }}
                                                ></i>
                                              </a>
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                  <br></br>
                                </div>

                                <button
                                  className="btn btn-success"
                                  data-toggle="modal"
                                  data-target="#modal-integracaonewitem"
                                  type="button"
                                  style={{ marginRight: 8 }}
                                >
                                  + Adicionar Nova Integração
                                </button>

                                <p>&nbsp;</p>
                                {/* /.box-body */}
                              </div>
                              {/* /.box */}
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      className="btn btn-default"
                      style={{ marginRight: 8 }}
                      onClick={() => history.push("/usuarios")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        className="modal fade"
        id="modal-newitem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Adicionar Treinamento</h4>
            </div>
            <div className="modal-body">
              <label>Treinamento</label>
              {produtosModalTreinamentos.length === 0 && idempresa && (
                <p className="text-muted" style={{ marginBottom: 8 }}>
                  Nenhum treinamento liberado para esta empresa. Configure
                  &quot;Treinamentos permitidos&quot; no cadastro do cliente.
                </p>
              )}
              <select
                id="idProduto"
                value={idproduto}
                placeholder="Produto do cliente"
                className="form-control select2"
                required
                onChange={(event) => setIdproduto(event.target.value)}
              >
                <option key="" value="" disabled>
                  -- Selecione --
                </option>
                
                {produtosModalTreinamentos.map((item, index) => (
                  <option key={item._id} value={item._id}>
                    {item.titulo}
                  </option>
                ))}
              </select>
            <br></br>
              <label>Prazo para conclusao
              </label>
              <DatePicker
                selected={datatreinamento}
                className="form-control"
                locale={br}
                required
                dateFormat="P"
                onChange={(date) => setDataTreinamento(date)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={() => addNewItem()}
              >
                Adicionar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      
      <div
        className="modal fade"
        id="modal-integracaonewitem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Adicionar Integração</h4>
            </div>
            <div className="modal-body">
              <label>Treinamento</label>
              <select
                id="idProduto"
                value={idproduto}
                placeholder="Produto do cliente"
                className="form-control select2"
                required
                onChange={(event) => setIdproduto(event.target.value)}
              >
                <option key="" value="" disabled>
                  -- Selecione --
                </option>
                
                {produtosInt.map((item, index) => (
                  <option key={item._id} value={item._id}>
                    {item.titulo}
                  </option>
                ))}
              </select>
            <br></br>
              <label>Prazo para conclusao
              </label>
              <DatePicker
                selected={datatreinamento}
                className="form-control"
                locale={br}
                required
                dateFormat="P"
                onChange={(date) => setDataTreinamento(date)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={() => addNewItem()}
              >
                Adicionar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      <div
        className="modal fade"
        id="modal-edititem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Editar Treinamento</h4>
            </div>
            <div className="modal-body">
              <label>Treinamento</label>
              <select
                id="idProduto"
                value={idproduto}
                placeholder="Produto do cliente"
                className="form-control select2"
                required
                disabled
              >
                <option key="" value="" disabled>
                  -- Selecione --
                </option>
                
                {produtos.filter(produto => (produto.isIntegracao == false)).map((item, index) => (
                  <option key={item._id} value={item._id}>
                    {item.titulo}
                  </option>
                ))}
              </select>
            <br></br>
              <label>Prazo para conclusao
              </label>
              <DatePicker
                selected={datatreinamento}
                className="form-control"
                locale={br}
                required
                dateFormat="P"
                onChange={(date) => setDataTreinamento(date)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={() => editItem(idprodutoCliente)}
              >
                Editar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      

      <Footer />
    </>
  );
}
